import { memo, useEffect, useMemo, useState } from 'react';
import { useCyberSportCategories, useFavorites } from '../../store';
import { sortFavoriteSports } from '../../utils';
import { CyberSportBaseMenuListItem } from './CyberSportBaseMenuListItem';

// actual: categories, displayed as: sports
// 'activeSportId' is actually 'activeCategoryId'
const CyberSportBaseMenuListBare = ({
  activeSportId,
  basePath,
  categoryRoute,
  showCategories,
  serviceId,
  eventId,
  categorySportId,
  tournamentId,
  countable = true,
  showPinIcon = false,
  categoriesWithIcon
}) => {
  const [isVisibleCurrentCategories, setIsVisibleCurrentCategories] =
    useState(true);

  useEffect(() => {
    if (
      tournamentId &&
      activeSportId === categorySportId &&
      !isVisibleCurrentCategories
    ) {
      setIsVisibleCurrentCategories(true);
    }
  }, [tournamentId]);

  useEffect(() => {
    if (eventId) {
      setIsVisibleCurrentCategories(true);
    }
  }, [eventId]);

  const favoriteCategories = useFavorites('categories');
  const categories = useCyberSportCategories();
  const categoryItems = useMemo(
    () => sortFavoriteSports(categories, favoriteCategories),
    [categories, favoriteCategories]
  );

  return categoryItems.map((category) => (
    <CyberSportBaseMenuListItem
      key={category.categoryId}
      category={category}
      tournamentId={tournamentId}
      activeSportId={activeSportId}
      isVisibleCurrentCategories={isVisibleCurrentCategories}
      setIsVisibleCurrentCategories={setIsVisibleCurrentCategories}
      showCategories={showCategories}
      basePath={basePath}
      countable={countable}
      showPinIcon={showPinIcon}
      serviceId={serviceId}
      categoryRoute={categoryRoute}
      categoriesWithIcon={categoriesWithIcon}
    />
  ));
};

export const CyberSportBaseMenuList = memo(CyberSportBaseMenuListBare);
